// third party
import { parseJSON, format, isDate, isValid, parse } from 'date-fns';

// project imports
import { isIRI } from './regexr';
import { renderUser } from 'ui-component/fields/EntitySelect/admin/UserSelect';

export const errorProcessor = (errorData = {}) => {
    if (typeof errorData === 'string') {
        return errorData;
    }
    if ('hydra:description' in errorData) {
        return errorData['hydra:description'];
    }
    if ('exception' in errorData) {
        return errorData.exception?.message;
    }
    if ('detail' in errorData) {
        return errorData.detail;
    }

    return null;
};

export const dataURItoBlob = (dataURI) => {
    // convert base64/URLEncoded data component to raw binary data held in a string
    let byteString;
    if (dataURI.split(',')[0].indexOf('base64') >= 0) byteString = atob(dataURI.split(',')[1]);
    else byteString = unescape(dataURI.split(',')[1]);

    // separate out the mime component
    const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

    // write the bytes of the string to a typed array
    const ia = new Uint8Array(byteString.length);
    for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }

    return new Blob([ia], { type: mimeString });
};

export const getIdFromObj = (value) => {
    if (typeof value === 'number') {
        return value;
    }
    if (typeof value === 'object' && !Array.isArray(value) && 'id' in (value || {})) {
        return value.id;
    }

    return undefined;
};

export const getIriFromObj = (value) => {
    if (typeof value === 'string' && isIRI(value)) {
        return value;
    }
    if (typeof value === 'object' && !Array.isArray(value) && '@id' in (value || {})) {
        return value['@id'].replace(/\/view(\/|$)/, '/');
    }

    return undefined;
};

export const processDateFieldInput = (fieldValue) => {
    if (typeof fieldValue === 'string') {
        return parseJSON(fieldValue);
    }
    if (isDate(fieldValue) && isValid(fieldValue)) {
        return fieldValue;
    }

    return null;
};

export const processDateFieldOutput = (fieldValue, outputFormat) => {
    if (typeof fieldValue === 'string' && isValid(new Date(fieldValue))) {
        return format(new Date(fieldValue), outputFormat);
    }
    if (isDate(fieldValue) && isValid(fieldValue)) {
        return format(fieldValue, outputFormat);
    }

    return null;
};

export const processTimeFieldInput = (fieldValue) => {
    if (typeof fieldValue === 'string') {
        const parsedDateTime = processDateFieldInput(fieldValue);

        if (isDate(parsedDateTime) && isValid(parsedDateTime)) {
            return parsedDateTime;
        }

        const parsedTime = parse(fieldValue, fieldValue.split(':').length === 3 ? 'HH:mm:ss' : 'HH:mm', new Date());
        return isValid(parsedTime) ? parsedTime : null;
    }

    return isDate(fieldValue) && isValid(fieldValue) ? fieldValue : null;
};

export const processTimeFieldOutput = (fieldValue) => {
    if (typeof fieldValue === 'string' && fieldValue) {
        return fieldValue;
    }

    return isDate(fieldValue) && isValid(fieldValue) ? format(fieldValue, 'HH:mm') : null;
};

export const processFilterRowOutput = (fr) => {
    const nfr = { ...fr };
    const outputFieldName = nfr?.field?.outputFieldName;

    if (outputFieldName) {
        nfr.field = { ...nfr.field, fieldName: outputFieldName };
        delete nfr.field.outputFieldName;
    }

    if (Array.isArray(nfr.value) && ['in', 'notIn']?.includes(nfr?.operator)) {
        nfr.value =
            outputFieldName || !/[A-Za-z]+By(?:Id)?$/.test(nfr?.field?.fieldName)
                ? nfr.value.map((val) => (typeof val === 'object' ? getIdFromObj(val) : val))
                : nfr.value.map((val) => (typeof val === 'object' ? renderUser(val, 'fullName') : val));
    }
    return nfr;
};
